package com.arena_web.data.api

import com.arena_web.data.dto.SendSupportMessageRequest
import com.arena_web.data.dto.SupportMessageDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class SupportApi(private val client: HttpClient) {

    suspend fun sendMessage(email: String, message: String): ApiResponse<SupportMessageDto> {
        return client.apiPost("v1/support/messages", SendSupportMessageRequest(email, message))
    }
}
